import { DECISION_MAKER_HASH_QUERY_PARAM_NAME } from '#src/app/pages/petitionDetails/shared/consts';
import { useQueryParamValue } from '#src/app/shared/hooks/location';

export function useDecisionMakerHash(): string | undefined {
	return useQueryParamValue(DECISION_MAKER_HASH_QUERY_PARAM_NAME);
}
